import { render } from "./WO.vue?vue&type=template&id=8f6dced2"
import script from "./WO.vue?vue&type=script&lang=js"
export * from "./WO.vue?vue&type=script&lang=js"

import "./WO.vue?vue&type=style&index=0&id=8f6dced2&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__